import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d132780e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attachment" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "preview-holder" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "preview-holder"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  class: "preview-holder"
}
const _hoisted_8 = {
  width: "400",
  controls: ""
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "download-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TickIcon = _resolveComponent("TickIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (this.hasImagePreview)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: this.downloadUrl,
          target: "_blank"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "preview",
              src: this.downloadUrl
            }, null, 8, _hoisted_4)
          ])
        ], 8, _hoisted_2))
      : (this.hasAudioPreview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("audio", {
              controls: "",
              src: this.downloadUrl
            }, null, 8, _hoisted_6)
          ]))
        : (this.hasVideoPreview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("video", _hoisted_8, [
                _createElementVNode("source", {
                  src: this.downloadUrl
                }, null, 8, _hoisted_9),
                _createTextVNode(" Your browser does not support HTML video. ")
              ])
            ]))
          : (_openBlock(), _createElementBlock("a", {
              key: 3,
              href: this.downloadUrl,
              target: "_blank"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_TickIcon, { name: "file" }),
                _createTextVNode(" " + _toDisplayString(this.attachmentLink.name), 1)
              ])
            ], 8, _hoisted_10))
  ]))
}